<template>
  <div class="dashboard-container p-6">
    <div
      class="welcome-card bg-surface-0 dark:bg-surface-900 rounded-lg shadow-sm border border-surface-200 dark:border-surface-700 p-6 mb-6"
    >
      <h1
        class="text-3xl font-medium text-surface-900 dark:text-surface-0 mb-2"
        data-test-id="home-page-welcome-message"
      >
        Welcome to the Extensions Admin Dashboard,
        <span v-if="frontegg.authState.user?.name" class="font-semibold">
          {{ firstName }}
        </span>
      </h1>
      <p class="text-surface-600 dark:text-surface-300 mb-4">
        Manage Reach's Tax Configurations from this central dashboard by
        selecting the page you want from the side bar, for more information,
        refer this to the
        <a
          href="https://withreach.atlassian.net/wiki/x/dYDfv"
          target="_blank"
          rel="noopener noreferrer"
          class="text-rch-black dark:text-surface-300 hover:text-surface-800 dark:hover:text-surface-200 font-medium underline"
        >
          user guide here.
        </a>
      </p>
      <div class="border-t border-surface-200 dark:border-surface-700 pt-4 mt-2">
        <p class="text-sm text-surface-500 dark:text-surface-400">
          Last login: {{ formatDateLocale(frontegg.authState.user?.lastLogin) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useFrontegg } from '@frontegg/vue'
import { formatDateLocale } from '@/util/dateUtils'

const frontegg = useFrontegg()

const firstName = computed(() => {
  return frontegg.authState.user?.name?.split(' ')[0] || ''
})
</script>

<style scoped>
.dashboard-container {
  max-width: 1200px;
  margin: 0 auto;
}

.welcome-card {
  border-left: 4px solid #1E1A15;
}

:root.dark .welcome-card {
  border-left-color: #FAF7F5;
}
</style>
